import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  padding: "32px 24px",
  width: "100%",
}));

export const Header = styled("div")(({ theme, isOrangeBorder }) => ({
  ...theme.mixins.flexCenterBetween,
  marginBottom: 24,
  paddingBottom: 16,
  borderBottom: `1px solid ${isOrangeBorder ? theme.palette.accent : theme.palette.primaryLight}`,
  color: theme.palette.textPrimary,
  fontSize: 14,

  [theme.down("sm")]: {
    ...theme.paddings(6, 10),
    flexWrap: "wrap",
    height: "auto",
    gap: 10,
  },
}));

export const HeaderRouteTitle = styled("div")(({ theme }) => ({}));

export const HeaderClassText = styled("div")(({ theme }) => ({
  [theme.down("sm")]: {
    textAlign: "right",
    flexGrow: 1,
  },
}));

export const InfoWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  gap: 30,

  [theme.down("sm")]: {
    ...theme.paddings(10, 0, 0),
    flexWrap: "wrap",
    justifyContent: "space-between",
  },
}));

export const AirlineAndSitsBlock = styled("div")(({ theme }) => ({
  display: "flex",
  gap: 8,

  [theme.down("sm")]: {
    width: "auto",
  },
}));

export const SitsCount = styled("div")(({ theme }) => ({
  color: theme.palette.textSecondary,
  fontSize: 11,
}));

export const AirlineLogo = styled("img")(({ theme }) => ({
  width: 90,
  height: 30,
}));

export const FlightNumbersBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  alignItems: "center",
  justifyContent: "center",
  gap: 5,

  [theme.down("sm")]: {
    width: "auto",
  },
}));

export const FlightNumber = styled("div")(({ theme }) => ({
  fontWeight: 500,
  fontSize: 14,
  color: theme.palette.textSecondary,
}));

export const StatusBadge = styled("div")(({ theme }) => ({
  padding: "4px 12px",
  borderRadius: 4,
  fontSize: 12,
  fontWeight: 500,
  border: `1px solid ${theme.palette.borderLight}`,
  background: theme.palette.bgAlt,
  color: theme.palette.textSecondary,

  "&.warning": {
    background: theme.palette.warningBg,
    borderColor: theme.palette.accentBorder,
    color: theme.palette.accentDark,
  },

  "&.charter": {
    background: theme.palette.successBg,
    borderColor: theme.palette.successBorder,
    color: theme.palette.successDark,
  },
}));

export const FlightTimingsBlock = styled("div")(({ theme }) => ({
  ...theme.paddings(10, 10, 0),

  display: "grid",
  gridTemplateColumns: "1fr 1fr 1fr",
  gap: 24,
  marginBottom: 24,

  [theme.down("xs")]: {
    gridTemplateColumns: "1fr",
    textAlign: "center",
  },

  [theme.down("md")]: {
    gap: "16px",
  },
}));

export const DepartureBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  color: theme.palette.textPrimary,
  textTransform: "capitalize",

  "& > span.airport": {
    fontSize: 32,
    fontWeight: 700,
    letterSpacing: "-1px",
    color: theme.palette.textPrimary,
    marginBottom: 4,
  },

  "& > span.terminal": {
    fontSize: 14,
    color: theme.palette.textSecondary,
    marginBottom: 16,
  },

  "& > span.time": {
    fontSize: 24,
    fontWeight: 600,
    color: theme.palette.textPrimary,
    marginBottom: 4,
  },

  "& > span.date": {
    fontSize: 13,
    color: theme.palette.textMuted,
  },
}));

export const DurationBlock = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  paddingTop: 40,

  "& > div.duration-time": {
    marginTop: 8,
    fontSize: 13,
    color: theme.palette.textSecondary,
    fontWeight: 500,
  },

  "& > div.flight-line": {
    ...theme.mixins.flexAlignCenter,
    borderRadius: 2.5,
    width: "100%",
    height: 5,

    "& > div": {
      backgroundColor: theme.palette.borderLight,
      borderRadius: 2,
      margin: "0 1px",

      "&:hover": {
        backgroundColor: theme.palette.accent,
        cursor: "default",
      },
    },

    [theme.down("xs")]: {
      width: "50%",
    },
  },

  "& > div.segments": {
    fontSize: 10,
    fontWeight: 600,
    color: theme.palette.textMuted,
    textAlign: "center",
  },
}));

export const ArrivalBlock = styled(DepartureBlock)(({ theme }) => ({
  textAlign: "right",

  [theme.down("xs")]: {
    textAlign: "center",
  },
}));

export const TariffItem = styled("div")(({ theme }) => ({
  ...theme.paddings(10, 0),
  ...theme.mixins.flexColumn,
  alignItems: "center",
  justifyContent: "center",
  gap: 2,
  border: "2px solid transparent",
  cursor: "pointer",

  "&.single": {
    ...theme.paddings(0),
  },

  "&.active": {
    borderColor: theme.palette.accent,
  },

  "&.single.active": {
    borderColor: "transparent",
  },
}));

export const TariffItemPrice = styled("div")(({ theme }) => ({
  fontSize: 14,
  color: theme.palette.textMuted,
  fontWeight: 700,
  textTransform: "uppercase",
  paddingBottom: 5,
}));

export const TariffItemIcons = styled("div")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  gap: 3,
  fontSize: 26,
  lineHeight: 1,
  color: theme.palette.primaryDark,

  "& .notActive": {
    color: theme.palette.textMuted,
  },

  "& > div": {
    display: "flex",
    position: "relative",
  },

  "& .hand-luggage-weight": {
    position: "absolute",
    top: 9,
    fontSize: 12,
    width: "100%",
    textAlign: "center",
    fontWeight: "bold",
    lineHeight: 1,
  },

  "& .baggage-weight": {
    position: "absolute",
    top: 8,
    left: 7,
    width: 12,
    height: 12,
    textAlign: "center",
    backgroundColor: theme.palette.white,
    fontSize: 10,
    fontWeight: "bold",
    lineHeight: 1,
  },
}));

export const TariffItemDetails = styled("div")(({ theme }) => ({
  fontSize: 10,
  color: theme.palette.textMuted,
  borderBottom: `1px solid ${theme.palette.textPrimary}`,
}));

export const TariffItemTitle = styled(TariffItemPrice)(({ theme }) => ({
  paddingBottom: 0,
}));

export const DetailsAndRulesBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  position: "relative",
  height: 33,
  paddingTop: 10,
  paddingBottom: 5,
}));

export const DetailsButton = styled("button")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  border: "none",
  backgroundColor: "transparent",
  color: theme.palette.primaryLight,
  fontSize: 13,
  lineHeight: 1,
  cursor: "pointer",

  "& > span": {
    fontSize: 11,
    lineHeight: 1,
  },

  "& > span.active": {
    transform: "rotate(90deg)",
  },
}));

export const RulesButton = styled("button")(({ theme }) => ({
  position: "absolute",
  right: 10,
  bottom: 5,
  fontSize: 10,
  border: "none",
  backgroundColor: "transparent",
  textDecoration: "underline",

  "&:hover": {
    cursor: "pointer",
    textDecoration: "none",
  },
}));

export const Divider = styled("div")(({ theme }) => ({
  width: "100%",
  height: "1px",
  background: theme.palette.borderLight,
  margin: "24px 0",
}));

export const FlightDetails = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  gap: 10,
  padding: 10,
}));

export const FlightSegment = styled("div")(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(4, 1fr)",
  gap: 24,

  "& > .flightInfo": {
    "& > .subValue": {
      fontSize: 13,
      color: theme.palette.textSecondary,
    },
  },

  [theme.down("sm")]: {
    gridTemplateColumns: "1fr",
  },

  [theme.down("md")]: {
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: "16px",
  },
}));

export const FlightInfo = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "3px",

  "& > .title": {
    fontWeight: 400,
    fontSize: 12,
    color: theme.palette.textMuted,
    textTransform: "uppercase",
    letterSpacing: 0.5,
    marginBottom: 6,
  },

  "& > .value": {
    fontWeight: 600,
    fontSize: 15,
    color: theme.palette.textPrimary,

    "& > span": {
      textTransform: "capitalize",
    },

    "& > p": {
      fontWeight: 400,
      fontSize: 13,
      color: theme.palette.textSecondary,
    },
  },

  "&> .subValue": {
    fontWeight: 400,
    fontSize: 13,
    color: theme.palette.textSecondary,
  },
}));

export const FlightSegmentTimeAircraft = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  flexWrap: "wrap",
  gap: 10,

  "& > .flightAndDuration": {
    ...theme.mixins.flexAlignCenter,
    gap: 10,

    "& > .duration": {
      fontSize: 10,
    },
  },
}));

export const FlightSegmentTimings = styled("div")(({ theme }) => ({
  display: "flex",
  gap: 20,
  width: "100%",

  "& > .flightTime": {
    color: theme.palette.textPrimary,
    fontSize: 14,

    "& > span": {
      color: theme.palette.textMuted,
      fontSize: 12,
      paddingLeft: 5,
    },
  },

  "& > .flightPlace": {
    display: "flex",
    gap: 10,

    "& > .flightPlaceCode": {
      fontSize: 12,
      color: theme.palette.textPrimary,
      textTransform: "uppercase",
    },

    "& > .flightPlaceName": {
      ...theme.mixins.flexColumn,

      "& > span": {
        color: theme.palette.textMuted,
        fontSize: 12,
        lineHeight: "20px",
      },
    },
  },
}));

export const FlightBaggageInformation = styled("div")(({ theme }) => ({}));

export const FlightSegmentIcons = styled("div")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  gap: 3,
  paddingTop: 5,
  fontSize: 20,
  lineHeight: 1,
  color: theme.palette.primaryDark,

  "& .hasNotBaggage": {
    color: theme.palette.errorDark,
  },
}));

export const TransferBlock = styled("div")(({ theme }) => ({}));

export const TransferTime = styled("div")(({ theme }) => ({
  color: theme.palette.primaryLight,
  fontSize: 14,
}));
